import React, { cloneElement } from 'react';
import { Heading } from '@nerdwallet/currency';
import { sanitizeNode } from '../lib/utils';
import { If } from '../control-statements';
import styles from '../marketplace-product-card.module.less';

/**
 * Base component for rendering the card header.
 */
var BaseHeader = function BaseHeader(_ref) {
  var applyNowNode = _ref.applyNowNode,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rawHeading = _ref.heading,
      shouldOmitCta = _ref.shouldOmitCta,
      shouldOmitRating = _ref.shouldOmitRating,
      starRatingNode = _ref.starRatingNode;
  var heading = /*#__PURE__*/React.createElement(Heading, {
    color: "neutral-darkest",
    className: styles.heading,
    level: "2",
    size: "3"
  }, sanitizeNode(rawHeading));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, shouldOmitCta ? heading : /*#__PURE__*/cloneElement(applyNowNode, {
    className: styles.headingLink
  }, heading), !shouldOmitRating ? /*#__PURE__*/cloneElement(starRatingNode, {
    className: styles.starRatingContainer
  }) : null);
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  BaseHeader.propTypes = {
    applyNowNode: PropTypes.ReactElement,
    className: PropTypes.string,
    heading: PropTypes.ReactNode,
    shouldOmitCta: PropTypes.bool,
    shouldOmitRating: PropTypes.bool,
    starRatingNode: PropTypes.ReactElement
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires */
}

export default BaseHeader;